<div class="text-nowrap">
  <label id="{{'chart-input-label-' + chartInput.id}}" for="{{'chart-input-' + chartInput.id}}"
         class="form-label mb-0 me-1">{{chartInput.label}}</label>
</div>
<div class="input-group input-group-sm has-validation">
  <input id="{{'chart-input-' + chartInput.id}}"
         class="form-control"
         [class.is-invalid]="isInvalid"
         [class.is-valid]="!!value?.length && isInvalid === false"
         [disabled]="redshiftMode === 'estimated'"
         [(ngModel)]="value"
         (ngModelChange)="valueChangedWithDebounceTime()">
  <button *ngIf="value !== null && value !== undefined && redshiftMode === 'manual'"
          class="btn btn-light border-dark"
          type="button"
          (click)="clearChartInputValue()">
    <i class="fa-light fa-xmark"></i>
  </button>
  <div class="invalid-tooltip">
    <i class="fa-light fa-circle-exclamation me-1"></i>{{errorMessage}}
  </div>
  <div ngbDropdown>
    <button id="redshift-options"
            ngbDropdownToggle
            class="btn btn-sm btn-light border-dark"
            style="border-top-left-radius: 0; border-bottom-left-radius: 0"
            placement="bottom-end"
            ngbTooltip="{{tooltipRedshiftMode[redshiftMode]}}"
            container="body">
      {{redshiftMode}}
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
      <button id="redshift-manual"
              *ngIf="redshiftMode !== 'manual'"
              ngbDropdownItem
              (click)="setRedshiftMode('manual')">
        manual
      </button>
      <button id="redshift-estimated"
              *ngIf="redshiftMode !== 'estimated'"
              ngbDropdownItem
              (click)="setRedshiftMode('estimated')">
        estimated
      </button>
    </div>
  </div>
</div>
